import React, { useState } from 'react';
import { PurchaseOrderFilters } from '../../../../app/models/PurchaseOrder';

type Props = {
    filter: PurchaseOrderFilters;
    setFilter: (filter: PurchaseOrderFilters) => void;
};

const PurchaseOrderFilter = ({ filter, setFilter }: Props) => {
    const [localFilter, setLocalFilter] = useState<PurchaseOrderFilters>({ ...filter });

    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setLocalFilter({ ...localFilter, [e.target.name]: e.target.value });
    };

    const search = () => {
        setFilter({ ...localFilter, page: 1 });
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') search();
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="id">
                            Id Orden de Compra
                        </label>
                        <input
                            title="Orden de Compra"
                            type="number"
                            id="id"
                            name="id"
                            className="form-control form-control-sm"
                            value={localFilter.id ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="society">
                            Sociedad
                        </label>
                        <input
                            title="Sociedad"
                            type="text"
                            id="society"
                            name="society"
                            className="form-control form-control-sm"
                            value={localFilter.society ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="provider">
                            Proveedor
                        </label>
                        <input
                            title="Proveedor"
                            type="text"
                            id="provider"
                            name="provider"
                            className="form-control form-control-sm"
                            value={localFilter.provider ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <label htmlFor="status" className="mb-1 font-size-10">Estado</label>
                    <select
                        id="status"
                        name="status"
                        className="form-select form-select-sm"
                        value={localFilter.status ?? ''}
                        onChange={handlerInputFilter}
                    >
                        <option value="">Todos</option>
                        <option value="DRAFT">Borrador</option>
                        <option value="PENDING">Por confirmar</option>
                        <option value="CONFIRMED">Confirmado</option>
                    </select>
                </div>
                <div className="col-md-auto d-flex align-items-center">
                    <div className="mb-0 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={search}
                        >
                            <i className="mdi mdi-magnify me-1" />
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
            <div className="row mt-1">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="created_at_from">
                            Fecha de creación desde
                        </label>
                        <input
                            title="Fecha de creación desde"
                            type="date"
                            id="created_at_from"
                            name="created_at_from"
                            className="form-control form-control-sm"
                            value={localFilter.created_at_from ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="created_at_until">
                            Fecha de creación hasta
                        </label>
                        <input
                            title="Fecha de creación hasta"
                            type="date"
                            id="created_at_until"
                            name="created_at_until"
                            className="form-control form-control-sm"
                            value={localFilter.created_at_until ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseOrderFilter;
